module.exports = __webpack_public_path__ + "static/media/horoscope-icon-3.3d62fa26.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-3.png
// module id = 1529
// module chunks = 0